import {
  MAIN_LAYOUT_FOOTER_HEIGHT,
  MAIN_LAYOUT_HEADER_HEIGHT,
} from 'shared/styles/constants';

import type { Size } from './sideBarDialog.type';

export const SIZE = {
  xSmall: '20rem',
  small: '26rem',
  medium: '29rem',
  large: '32rem',
  xLarge: '40rem',
} as Record<Size, string>;

export const MARGIN_TOP_TOOLBAR = MAIN_LAYOUT_HEADER_HEIGHT;

export const MARGIN_BOTTOM_TOOLBAR = MAIN_LAYOUT_FOOTER_HEIGHT;
